import { useEffect } from "react";
import RoleGuard from "../../RoleGuard";
import { useAppSelector } from "../../../ReduxToolkit/Hooks";
import CivilStatusContainer from "../../../Components/MasterData/CivilStatus";

const CivilStatus = () => {
  const { user } = useAppSelector((state) => state.auth);
  const currentUserRoles = user?.roles?.map((role) => role.slug) || [];
  useEffect(() => {
    document.title = "Civil Status Master Data";
  }, []);

  return (
    <>
      {/* RoleGuard ensures only allowed roles can view the page */}
      <RoleGuard
        userRoles={currentUserRoles}
        allowedRoles={["admin", "data-master"]}
      />

      {/* Main content */}
      <CivilStatusContainer />
    </>
  );
};

export default CivilStatus;
